import React from "react";
import Modal from "../../../../components/Modal/Modal";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../routes/routeKeys";

const BrokerDetailsModal = ({ showModal, onClose, broker }) => {
  const navigate = useNavigate();

  if (!broker) return null;

  const { role, details } = broker;
  // Assume users if "inside", "bds", or round_robin exists
  const isInternalUser = role.includes("inside") || role.includes("bds") || details?.round_robin !== undefined;
  
  const handleEditNavigate = () => {
    if (isInternalUser) {
      navigate(ROUTES.USER_DETAILS.replace(":id", details?.id));
    } else {
      navigate(ROUTES.CONTACT_DETAILS.replace(":id", details?.id));
    }
    onClose();
  };

  const getInitials = (firstName, lastName) => {
    return `${firstName?.charAt(0) || ""}${lastName?.charAt(0) || ""}`.toUpperCase();
  };

  const roleName = role.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase());

  return (
    <Modal 
      title={`${roleName} Details`} 
      desc={`View details for this ${roleName.toLowerCase()} here.`}
      show={showModal} 
      onClose={onClose}
    >
      <div className="py-4">
        {/* Header Section */}
        <div className="flex items-start gap-4 mb-6">
          <div className="w-12 h-12 rounded-full flex items-center justify-center text-lg font-medium shrink-0 green-bg-H light-L">
            {getInitials(details?.first_name, details?.last_name)}
          </div>
          <div className="flex-1">
            <div className="flex justify-between items-start">
              <div>
                <p className="head-3 dark-H">{details?.name || `${details?.first_name || ""} ${details?.last_name || ""}`.trim()}</p>
                <p className="body-S green-H mt-1 capitalize">{roleName}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Details Grid */}
        <div className="flex flex-col gap-4 mb-6">
          <div className="flex">
            <p className="head-4 dark-H w-28">Company</p>
            <p className="body-N dark-M">{details?.company_name_full?.name || details?.company?.name || "N/A"}</p>
          </div>

          <div className="flex">
            <p className="head-4 dark-H w-28">Email</p>
            <p className="body-N dark-M">
              {details?.email_full?.work || details?.email_full?.personal || details?.email_full?.other || details?.email || "N/A"}
            </p>
          </div>

          <div className="flex">
            <p className="head-4 dark-H w-28">Phone</p>
            <p className="body-N dark-M">
              {details?.phone_full?.work || details?.phone_full?.home || details?.phone_full?.other || details?.phone || "N/A"}
            </p>
          </div>

          <div className="flex">
            <p className="head-4 dark-H w-28">Mobile</p>
            <p className="body-N dark-M">{details?.phone_full?.mobile || "N/A"}</p>
          </div>

          <div className="flex">
            <p className="head-4 dark-H w-28">Address</p>
            <p className="body-N dark-M">
              {details?.address_full ? 
                `${details?.address_full?.address || ""} ${details?.address_full?.city || ""} ${details?.address_full?.state || ""} ${details?.address_full?.zip_code || ""}`.trim() || "N/A"
                : "N/A"
              }
            </p>
          </div>
        </div>

        {/* About Section */}
        <div>
          <p className="head-4 dark-H mb-2">About</p>
          <p className="body-N dark-M leading-relaxed">
            {details?.about || details?.pipeline_detail || "No details available."}
          </p>
        </div>
        
        <div className="mt-8 border-t border-[#DFE1E6] pt-5">
          <button 
            type="button" 
            onClick={handleEditNavigate}
            className="save-button light-L head-5 green-bg-H"
          >
            View Profile
          </button>
          <button 
            type="button" 
            onClick={onClose} 
            className="green-H ml-5 head-5"
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default BrokerDetailsModal;
